module.exports = __webpack_public_path__ + "img/237-eaaf03.png";